import React from "react"
import Link from "gatsby-link"

const CookiesDialog = (props) => (  
  <div className="cookie-dialog">
    <div className="cookie-dialog-content">
      <h2 className="cookie-dialog-title">Cookie Policy</h2>
      <p className="cookie-dialog-text" data-text="This site uses cookies and other tracking technologies to assist with site navigation, analyse your use of our products and services. If you continue without changing your settings, we&apos;ll assume that you are happy to receive all cookies on this website. If you do not accept cookies, however, you may not be able to use all functionality of the website. Read more about cookies and how to disable them."></p>
    </div>
    <div className="cookie-dialog-buttons">
      <div className="cookie-dialog-readmore">
        <Link to="/cookie_policy.html">Read More</Link>
      </div>
      <div className="cookie-dialog-accept">
        <button type="button" onClick={props.controlFunc}>Accept</button>
      </div>
    </div>
  </div>
);

export default CookiesDialog;


// WEBPACK FOOTER //
// ./src/components/CookiesDialog.js